<div id="faq-section" class="watermark py-5">
  <div class="container-fluid px-lg-5">

    <!-- Stylized Header Badge replicating User Screenshot -->
    <div class="faq-header text-center mb-5">
      <div class="faq-badge-wrapper d-inline-block">
        <div class="faq-badge-icon">
          <i class="fa fa-graduation-cap"></i>
        </div>
        <h1 class="faq-main-title">FAQs</h1>
        <div class="faq-badge-divider">
          <span class="divider-dot"></span>
          <span class="divider-line"></span>
          <span class="divider-dot"></span>
        </div>
      </div>
      <p class="faq-subtitle text-muted mt-3">Find answers to commonly asked questions about admissions, academics, campus facilities, and student life.</p>
    </div>

    <!-- Accordion Section -->
    <div class="row justify-content-center">
      <div class="col-12 col-xl-10 col-xxl-9">
        <div class="faq-accordion">
          
          <div class="faq-card" *ngFor="let faq of faqs; let i = index" [class.faq-active]="activeIndex === i">
            <!-- Question Trigger -->
            <div class="faq-question-trigger d-flex justify-content-between align-items-center" (click)="toggleFAQ(i)">
              <div class="d-flex align-items-center gap-3">
                <span class="faq-number" [class.text-orange]="activeIndex === i">Q{{ i + 1 }}</span>
                <span class="faq-question">{{ faq.q }}</span>
              </div>
              <span class="faq-icon-holder">
                <i class="fa" [class.fa-minus]="activeIndex === i" [class.fa-plus]="activeIndex !== i"></i>
              </span>
            </div>

            <!-- Answer Block -->
            <div class="faq-answer-wrapper" 
                 [style.maxHeight]="activeIndex === i ? '300px' : '0px'"
                 [style.opacity]="activeIndex === i ? '1' : '0'">
              <div class="faq-answer-inner">
                <div class="faq-answer-marker"></div>
                <p class="faq-answer-text">{{ faq.a }}</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</div>
